// extracted by mini-css-extract-plugin
export default {"loading-overlay":"App_loading-overlay__dtdr2","overlay":"App_overlay__lCOsG"};